import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromAppDownload from './reducers/app-download.reducer';
import { AppDownloadEffects } from './effects/app-download.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('AppDownload', fromAppDownload.reducer),
    EffectsModule.forFeature([AppDownloadEffects])
  ]
})
export class AppDownloadModule { }
